<template>
	<div class="box">
		<el-row>
			<el-select v-model="receiptType" style="margin-right:15px;">
				<el-option label="采购" value="1"></el-option>
				<el-option label="未知" value="4"></el-option>
				<el-option label="库存" value="5"></el-option>
			</el-select>
			<el-date-picker
				v-model="startTimeString"
				@change="startTime"
				align="right"
				type="date"
				placeholder="选择开始日期"
				format="yyyy-MM-dd HH:mm:ss"
			></el-date-picker>
			<el-date-picker
				v-model="endTimeString"
				@change="endTime"
				align="right"
				type="date"
				placeholder="选择结束日期"
				format="yyyy-MM-dd HH:mm:ss"
				style="margin-left:15px;"
			></el-date-picker>
			<el-select
				v-model="recipient"
				filterable
				placeholder="请选择收件人"
				style="margin-left:15px;"
			>
				<el-option
					v-for="item in recipientList"
					:key="item"
					:label="item"
					:value="item"
				></el-option>
			</el-select>
			<el-select
				v-model="isRefund"
				placeholder="是否已退款"
				style="margin-left:15px;"
			>
				<el-option
					v-for="item in RefundList"
					:key="item.value"
					:label="item.label"
					:value="item.value"
				></el-option>
			</el-select>
			<el-input
				placeholder="原始单号、退件单号"
				style="width:300px;margin-left:15px;"
				v-model="searchString"
			></el-input>
			<el-button
				type="primary"
				style="margin-left:15px;"
				@click="searchForm"
				>搜索</el-button
			>
			<el-button type="primary" @click="reset">重置</el-button>
		</el-row>
		<el-table
			:data="tableData"
			:header-cell-style="headClass"
			v-loading="loading"
			border
			style="width: 100%;margin-top:20px;"
		>
			<el-table-column
				prop="receiptNumber"
				label="订单号/订单ID"
				align="left"
				width="240"
			>
				<template slot-scope="scope">
					<div>订单号：{{ scope.row.amazonOrderId }}</div>
					<div>订单ID：{{ scope.row.orderId }}</div>
				</template>
			</el-table-column>
			<el-table-column
				prop="receiptNumber"
				label="退件国内单号"
				align="center"
				width="170"
			>
				<template slot-scope="scope" v-if="scope.row.receiptNumber">
					<div v-if="scope.row.queryTrackSwitch == 1">
						<el-popover
							placement="left"
							width="800"
							trigger="click"
							:close-delay="0"
							@show="popoverShow(scope.row)"
						>
							<template>
								<div
									style="width: 100%;text-align: center;"
									v-if="popoverStatus"
								>
									{{ popoverText }}
								</div>
								<div style="width: 100%;" v-else>
									<div v-if="popoverInfo.number" style="margin-bottom: 10px;">
										<span>运单号：{{
											popoverInfo.number
										}}</span>
										<span style="margin-left: 10px;">{{
											popoverInfo.track_info.latest_status.status
										}}</span>
									</div>
									<div v-if="popoverInfo.track_info" style="margin-bottom: 10px;">
										<span>时效信息: </span>
										<span style="margin-left: 10px;">订单:{{
											popoverInfo.track_info.time_metrics.days_after_order
										}}天</span>
										<span style="margin-left: 10px;">运输:{{
											popoverInfo.track_info.time_metrics.days_of_transit
										}}天</span>
										<span style="margin-left: 10px;">妥投:{{
											popoverInfo.track_info.time_metrics.days_of_transit_done
										}}天</span>
										<span style="margin-left: 10px;">无更新:{{
											popoverInfo.track_info.time_metrics.days_after_last_update
										}}天</span>
									</div>
									<div v-if="popoverInfo.track_info"
												style="height: 200px;overflow: auto;">
										<div v-for="(item, index) in popoverInfo.track_info.tracking.providers[0].events" :key="index" style="margin-bottom: 5px;">
											<div>{{ item.description }}</div>
											<div>{{ timeConversion(item.time_iso) }}</div>
										</div>
									</div>
								</div>
							</template>
							<template slot="reference">
								<el-row
									type="flex"
									justify="center"
									align="middle"
								>
									<div
										style="cursor: pointer;"
										@click="
											queryDomesticOrderClick(scope.row)
										"
									>
										<span>{{
											scope.row.receiptNumber
										}}</span>
									</div>
								</el-row>
							</template>
						</el-popover>
					</div>
					<div v-if="scope.row.queryTrackSwitch !== 1">
						<span>{{ scope.row.receiptNumber }}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column
				prop="recipientName"
				label="单据号、批次号/数量"
				width="240"
			>
				<template slot-scope="scope">
					<p>
						单据号：{{ scope.row.unknownNumberOrPurchaseDocument }}
					</p>
					<p>
						<span v-if="scope.row.batchNo == null">批次号：-</span>
						<span v-if="scope.row.batchNo !== null"
							>批次号：{{ scope.row.batchNo }}</span
						>
						<span> / </span>
						<span>数量：{{ scope.row.returnCount }}</span>
					</p>
				</template>
			</el-table-column>
			<el-table-column
				prop="recipientName"
				label="收件人"
				align="center"
				width="100"
			></el-table-column>
			<el-table-column
				prop=""
				label="退件照片"
				align="center"
				width="100"
			>
				<template slot-scope="scope" v-if="scope.row.imageList">
					<div class="demo-image__preview">
						<el-image
							style="width: 55px; height: 55px"
							:src="scope.row.imageList[0]"
							:preview-src-list="scope.row.imageList"
						>
						</el-image>
					</div>
				</template>
			</el-table-column>
			<el-table-column align="center" width="200">
				<template slot="header">
					退货总费用/平均费用
					<el-popover trigger="hover" placement="top">
						<p>该费用为同一批次总费用和平均每一单的平均费用</p>
						<i class="iconfont icon-tishi" slot="reference"></i>
					</el-popover>
				</template>
				<template slot-scope="scope">
					<p>
						{{ scope.row.totalCharge }} /
						{{ scope.row.averageCost }}
					</p>
				</template>
			</el-table-column>
			<el-table-column label="是否已退款" align="center" width="100">
				<template slot-scope="scope">
					<span style="color:red;" v-if="scope.row.isRefund == 0"
						>否</span
					>
					<span v-if="scope.row.isRefund == 1">是</span>
				</template>
			</el-table-column>
			<el-table-column label="退件备注" align="center" width="200">
				<template slot-scope="scope">
					<p v-for="(item, index) in scope.row.remarks" :key="index">
						{{ item.remark }}
					</p>
				</template>
			</el-table-column>
			<el-table-column
				prop="internalConveyNumber"
				label="原国内单号"
				align="center"
				width="170"
			></el-table-column>
			<el-table-column
				width="110"
				sortable
				prop="createTime"
				label="退件时间"
				align="center"
			></el-table-column>
			<el-table-column
				width="110"
				label="操作"
				align="center"
				fixed="right"
			>
				<template slot-scope="scope">
					<el-button type="primary" @click="Edit(scope.row)"
						>编辑</el-button
					>
				</template>
			</el-table-column>
		</el-table>

		<el-dialog title="编辑" :visible.sync="dialogVisible" width="40%">
			<el-button
				type="primary"
				@click="associated"
				v-if="this.EditData.receiptType == 4"
				>关联采购单据</el-button
			>
			<el-row style="margin-top:20px;">
				<el-col :span="8">
					<label>采购价：</label>
					<el-input
						style="width:50%;"
						readonly
						v-model="infoData.purchasePrice"
						v-if="
							EditData.relatedPurchaseId == null ||
								EditData.relatedPurchaseId == ''
						"
					></el-input>
					<el-input
						style="width:50%;"
						readonly
						v-model="EditData.purchasePrice"
						v-if="
							EditData.relatedPurchaseId !== null &&
								EditData.relatedPurchaseId !== ''
						"
					></el-input>
				</el-col>
				<el-col :span="8">
					<el-tooltip
						class="item"
						effect="dark"
						content="采购平台退回的钱"
						placement="top"
					>
						<label>实际退款：</label>
					</el-tooltip>
					<el-input
						style="width:50%;"
						v-model="actualRefund"
					></el-input>
				</el-col>
				<el-col :span="8">
					<el-tooltip
						class="item"
						effect="dark"
						content="采购员给运营实际退回的钱"
						placement="top"
					>
						<label>运营退款：</label>
					</el-tooltip>
					<el-input
						style="width:50%;"
						v-model="operationalRefund"
					></el-input>
				</el-col>
			</el-row>
			<el-row style="margin-top:20px;">
				<el-card class="box-card" shadow="never">
					<div slot="header" class="clearfix">
						<span style="font-weight: bold;">备注</span>
						<el-button
							style="float: right; padding: 3px 0"
							type="text"
							@click="addremark"
							>添加备注</el-button
						>
					</div>
					<el-table :data="RemarksList" style="width: 100%">
						<el-table-column
							prop="roleName"
							label="操作人"
							align="center"
						></el-table-column>
						<el-table-column
							prop="remark"
							label="内容"
							align="center"
						></el-table-column>
						<el-table-column
							prop="createTime"
							label="创建时间"
							align="center"
						></el-table-column>
						<el-table-column label="操作" align="center" width="80">
							<template slot-scope="scope">
								<el-button
									type="text"
									style="color:red;"
									@click="del(scope.row)"
									>删除</el-button
								>
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</el-row>
			<p style="color:red;margin-top:15px;">
				注：该备注栏只适用于退款记录的备注！
			</p>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="save">保存</el-button>
			</span>
		</el-dialog>

		<div class="page">
			<el-pagination
				style="margin-right:200px;"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="[50, 100, 200, 400]"
				:page-size="pagesize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
		</div>
	</div>
</template>
<script>
import { ajaxPost, Baseurl } from '../../api/api/api'
export default {
	name: 'Returnrecord',
	data() {
		return {
			tableData: [],
			searchString: '',
			receiptType: '1',
			recipient: '',
			recipientList: [],
			startTimeString: '',
			endTimeString: '',
			EditData: '',
			isRefund: '',
			loading: false,
			dialogVisible: false,
			RemarksList: [],
			infoData: '',
			actualRefund: '',
			operationalRefund: '',
			RefundList: [
				{ label: '否', value: 0 },
				{ label: '是', value: 1 },
			],
			currentPage: 1,
			pagesize: 50,
			size: 50,
			total: 0,
			headClass: this.common.headClass,

			popoverText: '查询中...',
			popoverStatus: true,
			popoverInfo: null,
			popoverDomesticOrderStatus: {
				0: '在途',
				1: '揽收',
				2: '疑难',
				3: '签收',
				4: '退签',
				5: '派件',
				6: '退回',
				7: '转投',
				10: '待清关',
				11: '清关中',
				12: '已清关',
				13: '清关异常',
				14: '拒签',
			},
		}
	},
	created() {
		this.str = JSON.parse(localStorage.getItem('role'))
		this.search()
		this.selectrecipientList()
	},
	methods: {
		// 时间转换
		timeConversion(item){
			const date = new Date(item);
			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, '0');
			const day = date.getDate().toString().padStart(2, '0');
			const hour = date.getHours().toString().padStart(2, '0');
			const minute = date.getMinutes().toString().padStart(2, '0');
			const seconds = date.getSeconds().toString().padStart(2, '0');
			const formattedTime = `${year}/${month}/${day} ${hour}:${minute}:${seconds}`
			return formattedTime
		},
		searchForm() {
			this.currentPage = 1
			this.search()
		},
		search() {
			this.loading = true
			var obj = {
				receiptType: this.receiptType,
				recipientName: this.recipient,
				companyId: this.str.company_id,
				searchString: this.searchString,
				startTimeString: this.startTimeString,
				endTimeString: this.endTimeString,
				isRefund: this.isRefund,
				page: this.currentPage,
				size: this.size,
			}
			ajaxPost(
				Baseurl + 'logisticsController/selectReturnrecords',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.tableData = res.data.data.list
					this.total = res.data.data.total
				}
				this.loading = false
			})
		},
		selectrecipientList() {
			var obj = {
				companyId: this.str.company_id,
			}
			ajaxPost(
				Baseurl +
					'financeReportingController/getRecipientNameListByCompanyId',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.recipientList = res.data.data
				}
			})
		},
		reset() {
			this.receiptType = '1'
			this.currentPage = 1
			this.searchString = ''
			this.recipient = ''
			this.status = ''
			this.isRefund = ''
			this.startTimeString = ''
			this.endTimeString = ''
			this.search()
		},
		addremark() {
			this.$prompt('请输入备注', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
			}).then(({ value }) => {
				var obj = {
					remark: value,
					signRid: this.str.rid,
					financeReportId: this.EditData.id,
				}
				ajaxPost(
					Baseurl + 'returnRemarksController/insertReturnRemark',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						this.$message.success('添加备注成功')
						this.RemarkAjax()
						this.search()
					} else {
						this.$message.error(res.data.data)
					}
				})
			})
		},
		Edit(val) {
			this.dialogVisible = true
			this.EditData = val
			this.infoData = ''
			this.actualRefund = this.EditData.actualRefund
			this.operationalRefund = this.EditData.operationalRefund
			this.RemarkAjax()
			if (this.EditData.receiptType == 1) {
				this.purchaseNumber = this.EditData.purchaseNumber
				this.AssAjax()
			}
		},
		RemarkAjax() {
			var obj = {
				financeReportId: this.EditData.id,
			}
			ajaxPost(
				Baseurl + 'returnRemarksController/selectReturnRemarkList',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.RemarksList = res.data.data
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		del(val) {
			var obj = {
				id: val.id,
			}
			ajaxPost(
				Baseurl + 'returnRemarksController/deleteReturnRemark',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.$message.success('删除成功')
					this.RemarkAjax()
					this.search()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		associated() {
			this.$prompt('请输入采购单据', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern: /^[^\s]*$/,
				inputErrorMessage: '输入内容不能包含空格',
			}).then(({ value }) => {
				this.purchaseNumber = value
				this.AssAjax()
			})
		},
		AssAjax() {
			var obj = {
				purchaseNumber: this.purchaseNumber,
				companyId: this.str.company_id,
			}
			ajaxPost(
				Baseurl +
					'purchaseController/selectPurchaseByPurchaseNumberAndCompanyId',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.infoData = res.data.data
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		save() {
			if (Number(this.actualRefund) < Number(this.operationalRefund)) {
				this.$message.error('实际退款不能小于退款费用/运营退款')
				return
			}
			this.$confirm(
				'请确认是否已关联采购单据，如无关联，该单据运营退款无法针对订单进行回退',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}
			).then(() => {
				var obj = {
					id: this.EditData.id,
					roleId: this.str.rid,
					relatedPurchaseId: this.infoData.id,
					purchasePrice: this.infoData.purchasePrice,
					actualRefund: this.actualRefund,
					operationalRefund: this.operationalRefund,
				}
				ajaxPost(
					Baseurl +
						'financeReportingController/updateFinanceReporting',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						this.$message.success('保存成功')
						this.search()
					} else {
						this.$message.error(res.data.data)
					}
					this.actualRefund = ''
					this.operationalRefund = ''
				})
				this.dialogVisible = false
			})
		},
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.size = val
			this.search()
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.currentPage = val
			this.search()
		},
		queryDomesticOrderMove(item) {
			const API = Baseurl + 'conveyNumberQueryController/queryTrack'
			const paramsDate = {
				num: item.receiptNumber,
				companyId: item.companyId,
			}
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
						// console.log(data)
					} else {
						reject(data)
					}
				})
			})
		},
		async popoverShow(item) {
			this.popoverText = '查询中...'
			this.popoverStatus = true
			const queryTrackSwitch = this.str.company.queryTrackSwitch
			try {
				// 快递100物流轨迹查询
				// const data = await this.queryDomesticOrderMove(item)
				// if (data.status === '200') {
				// 	this.popoverStatus = false
				// 	this.popoverInfo = data
				// } else {
				// 	this.popoverText = data.message || '查询失败'
				// }
				if(queryTrackSwitch === 1) {
					const data = await this.query17Trackinfo(item)  // 17track物流轨迹查询
                    if (data.code === 0 && data.data.accepted && data.data.accepted.length > 0) {
						this.popoverStatus = false
						this.popoverInfo = data.data.accepted[0]
					} else if (data.code === 0 && data.data.rejected && data.data.rejected.length > 0) {
						this.popoverText = data.data.rejected[0].error.message
					} else {
						this.popoverText = data.message || '查询失败'
					}
				} else {
                    this.popoverText = '贵司尚未开启物流轨迹查询!'
                }
			} catch (error) {
				this.popoverText = error || '查询失败'
			}
		},
		query17Trackinfo(item) {
			const API = Baseurl + 'track17Controller/gettrackinfo'
			const paramsDate = [{
				number: item.receiptNumber.replace(/\s/g,''),
				carrier: !isNaN(item.companyCode) ? item.companyCode : null,
			}]
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		queryDomesticOrderClick(item) {
			console.log(item)
			const inputEle = document.createElement('input')
			inputEle.readOnly = 'readOnly'
			inputEle.style.position = 'absolute'
			inputEle.style.top = document.body.scrollTop
			inputEle.style.zIndex = '-1000'
			const appEle = document.getElementById('app')
			appEle.appendChild(inputEle)
			inputEle.setAttribute('value', item.internalConveyNumber)
			inputEle.select()
			// if (document.execCommand('copy')) {
			// 	this.$confirm('复制成功，点击确定跳转快递100页面', '提示').then(
			// 		() => {
			// 			window.open('https://www.kuaidi100.com/')
			// 		}
			// 	)
			// }
			appEle.removeChild(inputEle)
		},
		//选择开始时间
		startTime(val) {
			var d = new Date(val)
			var datetime =
				d.getFullYear() +
				'-' +
				(d.getMonth() + 1) +
				'-' +
				d.getDate() +
				' 00:00:00'
			this.startTimeString = datetime
			//console.log(val);
		},
		// 选择结束时间
		endTime(val) {
			var d = new Date(val)
			var datetime =
				d.getFullYear() +
				'-' +
				(d.getMonth() + 1) +
				'-' +
				d.getDate() +
				' 23:59:59'
			this.endTimeString = datetime
			// console.log(val);
		},
	},
}
</script>
<style lang="scss" scoped>
.box {
	margin-bottom: 50px;
}
.page {
	position: fixed;
	width: 100%;
	bottom: 0;
	background-color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 50px;
}
</style>
